/**
* Created by MARCIANO_8
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 07/02/2018.
*
* end-game Vue Component
*/
<template>

  <div class="end-game-inner">
    <img v-if="score" src="../assets/images/trophy.svg" alt="" class="trophy">
    <img v-else src="../assets/images/clock.svg" alt="" class="clock">
    <h2 v-if="score">¡Has terminado!</h2>
    <h2 v-else>¡Se acabó el tiempo!</h2>

    <div class="scores-container" v-if="score">
      <div class="score">
        <div class="score-data">{{time}}</div>
      </div>
    </div>
     <p class="score-msg" v-if="score">Este es tu registro. Espera la lista de ganadores el el sitio de promociones.</p>
    <p class="score-msg" v-else>No has completado el rompecabezas. <br>¡Gracias por participar!</p>
    <button class="btn-game-primary" @click="closeGame">ACEPTAR</button>
  </div>

</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
export default {
  name: 'EndGame',
  props: {
    time: {
      type: String,
      required: true
    },
    score: {
      type: Number,
      required: true
    }
  },
  methods: {
    closeGame () {
      this.$emit('closeGame')
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style lang="scss" scoped>
  @import "../assets/styles/variables";

  .scores-container {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding-bottom: 15px;
    .score {
      .score-data {
        @include font-game-primary(29px);
        color: $game-primary;
      }
      .score-label {
        @include font-game-primary(14px);
        color: #999999;
      }
    }

  }

  .btn-go-out {
    background-color: #00ADDA;
    color: #ffffff;
  }

  .end-game-logo {
    width: 200px;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  .end-game-inner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    text-align: center;
    background-color: #ffffff;
    box-shadow: 0 3px 46px rgba(0,0,0, 0.3);
    border-radius: 5px;
    width: 360px;
    max-width: 100%;
    padding: 30px;
    .trophy, .clock {
      position: relative;
      top: -30px;
      width: 115px;
      margin-top: -45px;
    }
    .clock{
      top: -40px;
      width: 100px;
    }
    h2 {
      font-size: 24px;
      color: $game-primary;
      margin-top: 0;
      margin-bottom: 10px;
    }
    .score-msg {
      @include font-game-primary(14px, regular);
      line-height: 25px;
      margin: 10px 0 30px;
      color: #333333;
    }
    .thanks-msg {
      @include font-game-primary(10px, semibold);
      color: #333333;
    }
  }
</style>
